import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'

import { IconButton, Tooltip } from '@mui/material'
import { ReactComponent as RentalFeeIcon } from 'assets/RentalFee.svg'

import T from 'T'
import StyledBadge from 'components/notes/common/StyledBadge'
import RentalFeesDialog from 'components/pricing/RentalFees/ConfiguredServices/RentalFeesDialog'
import RentalFeesDialogV2 from 'components/pricing/RentalFees/ConfiguredServices/RentalFeesDialogV2'
import RentalFeePopover from '../popover/RentalFeePopover'

const RentalFeeBadgeButton = ({
  size = 'small',
  rentalFeeCount = 0,
  configuredServiceId = '',
  pricedServiceId = '',
  canEdit = false,
  onSuccessCallback = noop,
  useV2 = false,
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [isOpenRentalFeesDialog, setIsOpenRentalFeesDialog] = useState(false)

  const hasRentalFees = useMemo(() => rentalFeeCount > 0, [rentalFeeCount])

  const handlePopoverOpen = event => setAnchorEl(event.currentTarget)
  const handlePopoverClose = () => setAnchorEl(null)

  const handleOpenRentalFeesDialog = () => {
    setIsOpenRentalFeesDialog(true)
  }

  const handleCloseRentalFeesDialog = () => {
    setIsOpenRentalFeesDialog(false)
  }

  return (
    <>
      <Tooltip arrow placement="bottom" title={T.RENTAL_FEES} disableHoverListener={hasRentalFees} disableInteractive>
        <IconButton
          size={size}
          disabled={!canEdit && !hasRentalFees}
          {...(canEdit && configuredServiceId && { onClick: handleOpenRentalFeesDialog })}
          {...(hasRentalFees && { onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose })}
          {...rest}
        >
          <StyledBadge badgeContent={rentalFeeCount}>
            <RentalFeeIcon />
          </StyledBadge>
        </IconButton>
      </Tooltip>
      {anchorEl && (
        <RentalFeePopover
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          configuredServiceId={configuredServiceId}
          pricedServiceId={pricedServiceId}
        />
      )}
      {useV2 ? (
        <RentalFeesDialogV2
          isOpen={isOpenRentalFeesDialog}
          configuredServiceId={configuredServiceId}
          onClose={handleCloseRentalFeesDialog}
          onSuccessCallback={onSuccessCallback}
        />
      ) : (
        <RentalFeesDialog
          isOpen={isOpenRentalFeesDialog}
          configuredServiceId={configuredServiceId}
          onClose={handleCloseRentalFeesDialog}
          onSuccessCallback={onSuccessCallback}
        />
      )}
    </>
  )
}

RentalFeeBadgeButton.propTypes = {
  size: PropTypes.string,
  rentalFeeCount: PropTypes.number,
  configuredServiceId: PropTypes.string,
  pricedServiceId: PropTypes.string,
  canEdit: PropTypes.bool,
  onSuccessCallback: PropTypes.func,
  useV2: PropTypes.bool,
}

export default RentalFeeBadgeButton
